import { CatHeading } from 'components/blocks-components';
import styles from '../../request-equipment-service.module.scss';
import cx from 'classnames';
import { Conditional, CustomStyledLabel } from '@cat-ecom/pcc-components';
import { useMemo } from 'react';
import { REQUEST_SERVICE_FORM_ATTRIBUTES } from '../../constant';
import { useTranslations } from 'next-intl';
import { getCustomDate } from '../../utils';
import { capitalizeText } from '@cat-ecom/common/utils/stringUtils';

const RequestServicePreferredDateTimeInfo = ({ requestServiceInfo }) => {
  const t = useTranslations();
  const isCustomDate =
    requestServiceInfo?.preferredDateTime?.type ===
    REQUEST_SERVICE_FORM_ATTRIBUTES.prefDateType.custom;

  const serviceDate = useMemo(() => {
    return isCustomDate
      ? getCustomDate(requestServiceInfo?.preferredDateTime?.dates)
      : t('ASAP');
  }, [isCustomDate, requestServiceInfo?.preferredDateTime?.dates, t]);

  return (
    <>
      <CatHeading variant="label">
        <CustomStyledLabel>{t('REQUEST_SERVICE_DATE')}:</CustomStyledLabel>
      </CatHeading>
      <div className="row mt-2">
        <div className="col-4 col-md-3 pe-2 pe-md-3 text-break">
          <CatHeading variant="body-sm" isDisabled>
            <CustomStyledLabel
              className={styles['request-service__font-color']}
            >
              {t('REG_BIRTHDAY_DATE')}
            </CustomStyledLabel>
          </CatHeading>
        </div>
        <div
          className={cx([
            'col-8 col-md-9 text-break',
            styles['request-service__fw-semi-bold']
          ])}
        >
          <CatHeading variant="body-sm">
            <CustomStyledLabel>{serviceDate}</CustomStyledLabel>
          </CatHeading>
        </div>
      </div>
      <Conditional test={isCustomDate}>
        <div className="row mt-3" data-testid="customTime">
          <div className="col-4 col-md-3 pe-2 pe-md-3 text-break">
            <CatHeading variant="body-sm" isDisabled>
              <CustomStyledLabel
                className={styles['request-service__font-color']}
              >
                {t('TIME')}
              </CustomStyledLabel>
            </CatHeading>
          </div>
          <div
            className={cx([
              'col-8 col-md-9 text-break',
              styles['request-service__fw-semi-bold']
            ])}
          >
            <CatHeading variant="body-sm">
              <CustomStyledLabel>
                {capitalizeText(t(requestServiceInfo?.preferredDateTime.time))}
              </CustomStyledLabel>
            </CatHeading>
          </div>
        </div>
      </Conditional>
    </>
  );
};
export default RequestServicePreferredDateTimeInfo;
